import { ActivityState } from '@/api/models/activity'
import type { FrontActivityPart } from '@/store/slices/aggregateSlice/types/FrontActivityPart.type'
import type { FrontActivityWithAggregate } from '@/store/slices/aggregateSlice/types/FrontActivityWithAggregate.type'

export const filterArchivedActivities = (activityPart: FrontActivityPart<FrontActivityWithAggregate>) =>
  activityPart.childActivity.state !== ActivityState.archived
